import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';

const LeadershipSection = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <>
    <section className="section section-light" style={{ position: 'relative', overflow: 'hidden' }}>
      {/* Decorative elements */}
      <div style={{
        position: 'absolute',
        top: '10%',
        left: '5%',
        width: '200px',
        height: '200px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.05) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '10%',
        right: '5%',
        width: '200px',
        height: '200px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.05) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <h2 className="fade-in leadership-title" style={{ 
          fontSize: '2.5rem', 
          marginBottom: '1rem',
          position: 'relative',
          paddingBottom: '1.5rem',
          color: '#1a202c',
          textAlign: 'center'
        }}>
          {t('about.leadership.title')}
        </h2>
        
        <p className="subtitle fade-in" style={{ 
          maxWidth: '800px',
          margin: '0 auto 3rem',
          fontSize: '1.125rem',
          color: '#4a5568',
          textAlign: 'center'
        }}>
          {language === 'fr' 
            ? 'Notre équipe de direction apporte une expertise approfondie et une vision stratégique pour guider ASSCO vers l\'excellence dans le secteur Pétrole, Gaz et Industrie.' 
            : language === 'ar'
            ? 'يجلب فريق القيادة لدينا خبرة عميقة ورؤية استراتيجية لتوجيه ASSCO نحو التميز في قطاع النفط والغاز والصناعة.'
            : 'Our leadership team brings deep expertise and strategic vision to guide ASSCO towards excellence in the Oil, Gas and Industry sector.'}
        </p>
        
        <div className="leadership-card-container" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '2rem',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          <div className="leadership-card fade-in" style={{ 
            width: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
            borderRadius: 'var(--radius-lg)',
            overflow: 'hidden',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2), 0 10px 10px -5px rgba(0, 0, 0, 0.1)',
            transition: 'transform 0.3s, box-shadow 0.3s',
            border: '1px solid rgba(255, 255, 255, 0.15)'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-10px)';
            e.currentTarget.style.boxShadow = '0 25px 50px -12px rgba(0, 0, 0, 0.25)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'var(--shadow-xl)';
          }}>
            <div style={{ 
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap'
            }}>
              <div style={{ 
                flex: '1 1 250px',
                backgroundColor: 'var(--assco-gray-900)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2rem 1.5rem',
                position: 'relative',
                overflow: 'hidden'
              }}>
                {/* Background pattern */}
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cpath d='M0,0 L100,0 L100,100 L0,100 Z' fill='none' stroke='%23ffffff' stroke-opacity='0.05' stroke-width='1'/%3E%3C/svg%3E")`,
                  backgroundSize: '20px 20px',
                  opacity: 0.3
                }}></div>
                
                {/* Profile image */}
                <div style={{
                  width: '140px',
                  height: '140px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--assco-gray-800)',
                  border: '3px solid var(--assco-orange)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '3rem',
                  fontWeight: '800',
                    color: '#1a202c',
                  marginBottom: '1.5rem',
                  position: 'relative',
                  zIndex: 2,
                  boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.3)'
                }}>
                  AF
                </div>
                
                <h3 style={{ 
                  fontSize: '1.5rem',
                  color: 'white',
                  marginBottom: '0.5rem',
                  position: 'relative',
                  zIndex: 2
                }}>
                  Allaoua Felfoul
                </h3>
                
                <p style={{ 
                  color: 'var(--assco-orange)',
                  fontWeight: '600',
                  fontSize: '1rem',
                  marginBottom: '1.25rem',
                  position: 'relative',
                  zIndex: 2
                }}>
                  {language === 'fr' ? 'Directeur Général' : 
                   language === 'ar' ? 'المدير العام' : 
                   'General Manager'}
                </p>
                
                <div style={{
                  display: 'flex',
                  gap: '1rem',
                  position: 'relative',
                  zIndex: 2
                }}>
                  <a href="#" style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                      color: '#1a202c',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--assco-orange)';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
                    </svg>
                  </a>
                  
                  <a href="#" style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                      color: '#1a202c',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--assco-orange)';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                    </svg>
                  </a>
                  
                  <a href="#" style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                      color: '#1a202c',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--assco-orange)';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                  </a>
                </div>
              </div>
              
              <div style={{ 
                flex: '1 1 250px',
                padding: '3rem 2rem'
              }}>
                <h4 style={{ 
                  fontSize: '1.125rem',
                  fontWeight: '600',
                  marginBottom: '1.25rem',
                    color: '#1a202c',
                  position: 'relative',
                  paddingBottom: '0.75rem'
                }}>
                  {language === 'fr' ? 'Parcours Professionnel' : 
                   language === 'ar' ? 'المسار المهني' : 
                   'Professional Background'}
                  <span style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '50px',
                    height: '3px',
                    backgroundColor: 'var(--assco-orange)',
                    borderRadius: '1.5px'
                  }}></span>
                </h4>
                
                <div className="career-timeline">
                  <div className="timeline-item" style={{
                    display: 'flex',
                    marginBottom: '1.5rem',
                    alignItems: 'flex-start'
                  }}>
                    <div style={{ 
                      width: '12px', 
                      height: '12px', 
                      borderRadius: '50%',
                      backgroundColor: 'var(--assco-orange)',
                      marginRight: language === 'ar' ? 0 : '1rem',
                      marginLeft: language === 'ar' ? '1rem' : 0,
                      marginTop: '0.25rem',
                      flexShrink: 0
                    }}></div>
                    <div>
                      <div style={{ 
                        fontWeight: '600',
                        color: '#1a202c',
                        marginBottom: '0.25rem'
                      }}>
                        2025-{language === 'fr' ? 'Présent' : language === 'ar' ? 'الحاضر' : 'Present'}
                      </div>
                      <div style={{ 
                        color: '#1a202c',
                        fontWeight: '600',
                        marginBottom: '0.5rem'
                      }}>
                        {language === 'fr' ? 'Fondation d\'ASSCO' : 
                         language === 'ar' ? 'تأسيس ASSCO' : 
                         'Foundation of ASSCO'}
                      </div>
                      <div style={{ 
                        color: '#4a5568',
                        fontSize: '0.875rem',
                        lineHeight: '1.4'
                      }}>
                        {language === 'fr' ? 'Création d\'ASSCO pour fournir des solutions d\'instrumentation pétrochimique de premier ordre en Algérie.' : 
                         language === 'ar' ? 'إنشاء ASSCO لتوفير حلول أجهزة القياس البتروكيماوية من الدرجة الأولى في الجزائر.' : 
                         'Creation of ASSCO to provide premier petrochemical instrumentation solutions in Algeria.'}
                      </div>
                    </div>
                  </div>
                  
                  <div className="timeline-item" style={{
                    display: 'flex',
                    marginBottom: '1.5rem',
                    alignItems: 'flex-start'
                  }}>
                    <div style={{ 
                      width: '12px', 
                      height: '12px', 
                      borderRadius: '50%',
                      backgroundColor: 'var(--assco-gray-400)',
                      marginRight: language === 'ar' ? 0 : '1rem',
                      marginLeft: language === 'ar' ? '1rem' : 0,
                      marginTop: '0.25rem',
                      flexShrink: 0
                    }}></div>
                    <div>
                      <div style={{ 
                        fontWeight: '600',
                        color: '#1a202c',
                        marginBottom: '0.25rem'
                      }}>
                        2008-2017
                      </div>
                      <div style={{ 
                        color: '#1a202c',
                        fontWeight: '600',
                        marginBottom: '0.5rem'
                      }}>
                        {language === 'fr' ? 'Ingénieur de Service chez Baker Hughes' : 
                         language === 'ar' ? 'مهندس خدمة في Baker Hughes' : 
                         'Service Engineer at Baker Hughes'}
                      </div>
                      <div style={{ 
                        color: '#4a5568',
                        fontSize: '0.875rem',
                        lineHeight: '1.4'
                      }}>
                        {language === 'fr' ? 'Spécialisation dans les instruments de mesure de débit, de gaz et d\'humidité.' : 
                         language === 'ar' ? 'التخصص في أدوات قياس التدفق والغاز والرطوبة.' : 
                         'Specialization in flow, gas and humidity measurement instruments.'}
                      </div>
                    </div>
                  </div>
                  
                  <div className="timeline-item" style={{
                    display: 'flex',
                    alignItems: 'flex-start'
                  }}>
                    <div style={{ 
                      width: '12px', 
                      height: '12px', 
                      borderRadius: '50%',
                      backgroundColor: 'var(--assco-gray-400)',
                      marginRight: language === 'ar' ? 0 : '1rem',
                      marginLeft: language === 'ar' ? '1rem' : 0,
                      marginTop: '0.25rem',
                      flexShrink: 0
                    }}></div>
                    <div>
                      <div style={{ 
                        fontWeight: '600',
                        color: '#1a202c',
                        marginBottom: '0.25rem'
                      }}>
                        2003-2008
                      </div>
                      <div style={{ 
                        color: '#1a202c',
                        fontWeight: '600',
                        marginBottom: '0.5rem'
                      }}>
                        {language === 'fr' ? 'Ingénieur chez General Electric' : 
                         language === 'ar' ? 'مهندس في General Electric' : 
                         'Engineer at General Electric'}
                      </div>
                      <div style={{ 
                        color: '#4a5568',
                        fontSize: '0.875rem',
                        lineHeight: '1.4'
                      }}>
                        {language === 'fr' ? 'Début de carrière avec GE après l\'acquisition de Panametrics en 2003.' : 
                         language === 'ar' ? 'بداية المسيرة المهنية مع GE بعد الاستحواذ على Panametrics في عام 2003.' : 
                         'Career beginning with GE after the acquisition of Panametrics in 2003.'}
                      </div>
                    </div>
                  </div>
                </div>
                
                <div style={{ 
                  marginTop: '2rem',
                  paddingTop: '2rem',
                  borderTop: '1px solid rgba(255, 255, 255, 0.2)'
                }}>
                  <h4 style={{ 
                    fontSize: '1.25rem',
                    fontWeight: '600',
                    marginBottom: '1rem',
                    color: '#1a202c'
                  }}>
                    {t('about.leadership.certifications')}
                  </h4>
                  
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '0.75rem'
                  }}>
                    <span style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      color: '#1a202c',
                      padding: '0.5rem 1rem',
                      borderRadius: 'var(--radius-full)',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '16px', height: '16px', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                      </svg>
                      Baker Hughes Certified
                    </span>
                    
                    <span style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      color: '#1a202c',
                      padding: '0.5rem 1rem',
                      borderRadius: 'var(--radius-full)',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '16px', height: '16px', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                      </svg>
                      Baker Hughes Certified
                    </span>
                    
                    <span style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      color: '#1a202c',
                      padding: '0.5rem 1rem',
                      borderRadius: 'var(--radius-full)',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '16px', height: '16px', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                      </svg>
                      Panametrics Specialist
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="leadership-card fade-in" style={{ 
            width: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
            borderRadius: 'var(--radius-lg)',
            overflow: 'hidden',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2), 0 10px 10px -5px rgba(0, 0, 0, 0.1)',
            transition: 'transform 0.3s, box-shadow 0.3s',
            border: '1px solid rgba(255, 255, 255, 0.15)',
            animationDelay: '0.3s'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-10px)';
            e.currentTarget.style.boxShadow = '0 25px 50px -12px rgba(0, 0, 0, 0.25)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'var(--shadow-xl)';
          }}>
            <div style={{ 
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap'
            }}>
              <div style={{ 
                flex: '1 1 250px',
                backgroundColor: 'var(--assco-gray-900)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2rem 1.5rem',
                position: 'relative',
                overflow: 'hidden'
              }}>
                {/* Background pattern */}
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cpath d='M0,0 L100,0 L100,100 L0,100 Z' fill='none' stroke='%23ffffff' stroke-opacity='0.05' stroke-width='1'/%3E%3C/svg%3E")`,
                  backgroundSize: '20px 20px',
                  opacity: 0.3
                }}></div>
                
                {/* Profile image */}
                <div style={{
                  width: '140px',
                  height: '140px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--assco-gray-800)',
                  border: '3px solid var(--assco-orange)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '3rem',
                  fontWeight: '800',
                    color: '#1a202c',
                  marginBottom: '1.5rem',
                  position: 'relative',
                  zIndex: 2,
                  boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.3)'
                }}>
                  AEF
                </div>
                
                <h3 style={{ 
                  fontSize: '1.5rem',
                  color: 'white',
                  marginBottom: '0.5rem',
                  position: 'relative',
                  zIndex: 2
                }}>
                  Aimed Eddine Felfoul
                </h3>
                
                <p style={{ 
                  color: 'var(--assco-orange)',
                  fontWeight: '600',
                  fontSize: '1rem',
                  marginBottom: '1.25rem',
                  position: 'relative',
                  zIndex: 2
                }}>
                  {language === 'fr' ? 'Business Development Manager' : 
                   language === 'ar' ? 'مدير تطوير الأعمال' : 
                   'Business Development Manager'}
                </p>
                
                <div style={{
                  display: 'flex',
                  gap: '1rem',
                  position: 'relative',
                  zIndex: 2
                }}>
                  <a href="#" style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                      color: '#1a202c',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--assco-orange)';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
                    </svg>
                  </a>
                  
                  <a href="#" style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                      color: '#1a202c',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--assco-orange)';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                    </svg>
                  </a>
                  
                  <a href="#" style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                      color: '#1a202c',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--assco-orange)';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                  </a>
                </div>
              </div>
              
              <div style={{ 
                flex: '1 1 250px',
                padding: '3rem 2rem'
              }}>
                <h4 style={{ 
                  fontSize: '1.125rem',
                  fontWeight: '600',
                  marginBottom: '1.25rem',
                    color: '#1a202c',
                  position: 'relative',
                  paddingBottom: '0.75rem'
                }}>
                  {language === 'fr' ? 'Parcours Professionnel' : 
                   language === 'ar' ? 'المسار المهني' : 
                   'Professional Background'}
                  <span style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '50px',
                    height: '3px',
                    backgroundColor: 'var(--assco-orange)',
                    borderRadius: '1.5px'
                  }}></span>
                </h4>
                
                <div className="career-timeline">
                  <div className="timeline-item" style={{
                    display: 'flex',
                    marginBottom: '1rem',
                    alignItems: 'flex-start'
                  }}>
                    <div style={{ 
                      width: '12px', 
                      height: '12px', 
                      borderRadius: '50%',
                      backgroundColor: 'var(--assco-orange)',
                      marginRight: language === 'ar' ? 0 : '1rem',
                      marginLeft: language === 'ar' ? '1rem' : 0,
                      marginTop: '0.25rem',
                      flexShrink: 0
                    }}></div>
                    <div>
                      <div style={{ 
                        fontWeight: '600',
                        color: '#1a202c',
                        marginBottom: '0.25rem'
                      }}>
                        2020-{language === 'fr' ? 'Présent' : language === 'ar' ? 'الحاضر' : 'Present'}
                      </div>
                      <div style={{ color: '#4a5568' }}>
                        {language === 'fr' ? 'Business Development Manager, ASSCO' : 
                         language === 'ar' ? 'مدير تطوير الأعمال، ASSCO' : 
                         'Business Development Manager, ASSCO'}
                      </div>
                    </div>
                  </div>
                  
                  <div className="timeline-item" style={{
                    display: 'flex',
                    marginBottom: '1rem',
                    alignItems: 'flex-start'
                  }}>
                    <div style={{ 
                      width: '12px', 
                      height: '12px', 
                      borderRadius: '50%',
                      backgroundColor: 'var(--assco-gray-400)',
                      marginRight: language === 'ar' ? 0 : '1rem',
                      marginLeft: language === 'ar' ? '1rem' : 0,
                      marginTop: '0.25rem',
                      flexShrink: 0
                    }}></div>
                    <div>
                      <div style={{ 
                        fontWeight: '600',
                        color: '#1a202c',
                        marginBottom: '0.25rem'
                      }}>
                        2015-2020
                      </div>
                      <div style={{ color: '#4a5568' }}>
                        {language === 'fr' ? 'Responsable Commercial, Secteur Pétrole et Gaz' : 
                         language === 'ar' ? 'مسؤول تجاري، قطاع النفط والغاز' : 
                         'Commercial Manager, Oil and Gas Sector'}
                      </div>
                    </div>
                  </div>
                </div>
                
                <div style={{ 
                  marginTop: '2rem',
                  paddingTop: '2rem',
                  borderTop: '1px solid rgba(255, 255, 255, 0.2)'
                }}>
                  <h4 style={{ 
                    fontSize: '1.25rem',
                    fontWeight: '600',
                    marginBottom: '1rem',
                    color: '#1a202c'
                  }}>
                    {language === 'fr' ? 'Domaines d\'expertise' : 
                     language === 'ar' ? 'مجالات الخبرة' : 
                     'Areas of Expertise'}
                  </h4>
                  
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '0.75rem'
                  }}>
                    <span style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      color: '#1a202c',
                      padding: '0.5rem 1rem',
                      borderRadius: 'var(--radius-full)',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '16px', height: '16px', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                      {language === 'fr' ? 'Développement Commercial' : 
                       language === 'ar' ? 'تطوير الأعمال' : 
                       'Business Development'}
                    </span>
                    
                    <span style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      color: '#1a202c',
                      padding: '0.5rem 1rem',
                      borderRadius: 'var(--radius-full)',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '16px', height: '16px', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                      </svg>
                      {language === 'fr' ? 'Marketing Stratégique' : 
                       language === 'ar' ? 'التسويق الاستراتيجي' : 
                       'Strategic Marketing'}
                    </span>
                    
                    <span style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      color: '#1a202c',
                      padding: '0.5rem 1rem',
                      borderRadius: 'var(--radius-full)',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '16px', height: '16px', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      {language === 'fr' ? 'Gestion de Comptes Clés' : 
                       language === 'ar' ? 'إدارة الحسابات الرئيسية' : 
                       'Key Account Management'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <style jsx>{`
      .leadership-title::after {
        display: none !important;
      }
      
      @media (max-width: 1024px) {
        .leadership-card-container {
          grid-template-columns: 1fr !important;
          gap: 1.5rem !important;
          max-width: 500px !important;
        }
      }
      
      @media (max-width: 768px) {
        .leadership-card {
          margin-bottom: 1rem;
        }
        
        .leadership-card div[style*="flex: 1 1 250px"] {
          flex: 1 1 100% !important;
          padding: 1.5rem 1rem !important;
        }
        
        .leadership-card div[style*="flex: 1 1 300px"] {
          flex: 1 1 100% !important;
          padding: 1.5rem 1rem !important;
        }
      }
    `}</style>
    </>
  );
};

export default LeadershipSection;
